import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
// simport PieChart from "react-native-pie-chart";
// import { LineChart } from "react-native-chart-kit";
// import DropdownComponentz, {
//   SelectDeliveryPerson,
// } from "../../Components/DropdownComponentz";
import CustomCalendarSmall from "./CustomCalendarSmall";
import useAppNavigation from "../../Routes/useAppNavigation";

const { width, height } = Dimensions.get("window");
const DispatchDashboard = () => {
  const navigation = useAppNavigation();
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const screenWidth = Dimensions.get("window").width;

  const widthAndHeight = 175;
  const series = [311, 630, 183, 120];
  const series1 = [570, 430, 0, 0];

  const sliceColor = [
    "rgb(98, 197, 114)",
    "rgb(255, 153, 50)",
    "rgb(217, 91, 93)",
    "rgb(60, 72, 107)",
  ];
  const sliceColor1 = [
    "rgb(98, 197, 114)",
    "rgb(255, 153, 50)",
    "rgb(217, 91, 93)",
    "rgb(60, 72, 107)",
  ];
  const data = {
    labels: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
    ],
    datasets: [
      {
        data: [0, 2, 4, 6, 8, 10],
      },
    ],
  };
  const summaryData = [
    {
      deliveryPerson: "tam",
      ordersAssigned: 1707119783840,
      ordersStatus: "Inprogress",
    },
    {
      deliveryPerson: "final",
      ordersAssigned: 1707119713055,
      ordersStatus: "Delivered",
    },
    {
      deliveryPerson: "tam",
      ordersAssigned: 1707110750374,
      ordersStatus: "Return",
    },
    {
      deliveryPerson: "final",
      ordersAssigned: 1706853439307,
      ordersStatus: "Onging",
    },
    {
      deliveryPerson: "Dispatch Matin",
      ordersAssigned: 1706852432338,
      ordersStatus: "Cancelled",
    },
    {
      deliveryPerson: "Delivery Person Not Assigned",
      ordersAssigned: 1706705388836,
      ordersStatus: "Inprogress",
    },
  ];

  return (
    <SafeAreaView style={styles.MainView}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 10 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View style={Appstyles.fullAlignment}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <Text
            style={{
              color: AppColors.brown1,
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,
              marginLeft: 20,
            }}
          >
            Dispatch Dashboard
          </Text>
        </View>

        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={() => navigation.navigate("#")}>
            <Image
              source={AppImages.VechicleNoti}
              style={{ width: 20, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20, marginLeft: 15 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={{ marginTop: 20 }}>
          <View
            style={{
              backgroundColor: AppColors.white,
              marginHorizontal: 20,
              //paddingHorizontal: 20,
              // paddingVertical: 14,
              borderRadius: 10,
              // marginVertical: 10,
              borderColor: "#9C49001A",
              borderWidth: 1,
            }}
          >
            <View
              style={[
                styles.FlatImg,
                {
                  borderWidth: 1,
                  borderColor: "#9C49001A",
                  backgroundColor: AppColors.white,
                  borderRadius: 10,
                },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  marginLeft: 20,
                  paddingBottom: 14,
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    // alignItems: "center",
                    width: "40%",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                      marginTop: 10,
                    }}
                  >
                    {t("common:translation.Order Summary")}
                  </Text>
                </View>
                <View
                  style={{
                    width: "60%",
                  }}
                >
                  <CustomCalendarSmall />
                </View>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginLeft: 20,
                marginTop: 20,
              }}
            >
              <Text
                style={{
                  color: AppColors.dualbrown,
                  fontSize: 14,
                  fontFamily: AppFonts.OverpassMedium,
                  // width: "50%",
                  marginBottom: 15,
                }}
              >
                {t("common:translation.Total orders of the month")}
              </Text>
            </View>
            <View
              style={{
                marginLeft: 20,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: "#04B54C",
                    padding: 5,
                    paddingLeft: 20,
                    paddingRight: 20,
                    borderRadius: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.white,
                      fontFamily: AppFonts.OverpassMedium,
                      fontSize: 12,
                    }}
                  >
                    Increased by 0
                  </Text>
                </View>
                <View
                  style={{
                    marginLeft: 5,
                  }}
                >
                  <Image
                    source={AppImages.UpArrowGreen}
                    resizeMode="contain"
                    style={{ width: 14.08, height: 14.92 }}
                  />
                </View>
              </View>
              <View style={{ flexDirection: "row", marginTop: 5 }}>
                <Text
                  style={{
                    color: AppColors.dualbrown,

                    fontSize: 12,
                    marginLeft: 4,
                  }}
                >
                  *
                </Text>
                <Text
                  style={{
                    color: AppColors.dualbrown,
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 12,
                    marginLeft: 4,
                  }}
                >
                  As per last month
                </Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                // justifyContent: "space-between",
                margin: 20,
              }}
            >
              {/* <PieChart
                widthAndHeight={screenWidth * 0.4}
                series={series}
                sliceColor={sliceColor}
                coverRadius={0.75}
                coverFill={"#FFF"}
              ></PieChart> */}
              <View style={{ marginLeft: 50 }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(98, 197, 114)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Delivered
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(255, 153, 50)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Inprogress
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(217, 91, 93)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Cancel
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(60, 72, 107)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Return
                  </Text>
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20 }}></View>
            {/* <LineChart
              data={data}
              width={screenWidth * 0.8}
              height={200}
              chartConfig={{
                fillShadowGradient: "white",
                fillShadowGradientOpacity: 0,
                fillShadowGradientFrom: "white",
                fillShadowGradientTo: "white",
                // backgroundColor:"red",
                backgroundGradientFrom: "#ffffff",
                backgroundGradientTo: "#ffffff",
                decimalPlaces: 0,
                color: (opacity = 0.1) => `#8F4300`,
                labelColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
                propsForDots: {
                  r: "3",
                  strokeWidth: "2",
                  stroke: "#8F4300",
                  // Customize the color of the line
                },

                propsForBackgroundLines: {
                  stroke: "transparent", // Hide the background lines
                },
              }}
              bezier={false}
              style={
                {
                  //   marginVertical: 9,
                  //   borderRadius: 16,
                }
              }
            /> */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 5,
              }}
            >
              <Text
                style={{
                  color: AppColors.black,
                  fontSize: 14,
                  fontWeight: 400,
                  fontFamily: AppFonts.OverpassMedium,
                  // width: "50%",
                  marginBottom: 15,
                }}
              >
                {t("common:translation.Days of month")}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 20 }}>
          <View
            style={{
              backgroundColor: AppColors.white,
              marginHorizontal: 20,
              //paddingHorizontal: 20,
              // paddingVertical: 14,
              borderRadius: 10,
              // marginVertical: 10,
              borderColor: "#9C49001A",
              borderWidth: 1,
            }}
          >
            <View
              style={[
                styles.FlatImg,
                {
                  borderWidth: 1,
                  borderColor: "#9C49001A",
                  backgroundColor: AppColors.white,
                  borderRadius: 10,
                },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  marginLeft: 20,
                  // paddingBottom: 14,
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    // alignItems: "center",
                    width: "40%",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                    }}
                  >
                    {t("common:translation.Delivery Person Statistics")}
                  </Text>
                </View>
                <View
                  style={{
                    width: "60%",
                    paddingTop: 10,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 14,
                      marginLeft: 20,
                      color: AppColors.brown1,
                    }}
                  >
                    Select Delivery Person
                  </Text>
                  {/* <DropdownComponentz data={SelectDeliveryPerson} /> */}
                </View>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                // justifyContent: "space-between",
                margin: 20,
              }}
            >
              {/* <PieChart
                widthAndHeight={screenWidth * 0.4}
                series={series1}
                sliceColor={sliceColor1}
                coverRadius={0.75}
                coverFill={"#FFF"}
              ></PieChart> */}
              <View style={{ marginLeft: 50 }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(98, 197, 114)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Delivered
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(255, 153, 50)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Inprogress
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(217, 91, 93)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Cancel
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(60, 72, 107)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Return
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 15,
                      height: 15,
                      borderRadius: 50,
                      backgroundColor: "rgb(255, 253, 208)",
                    }}
                  ></View>
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginLeft: 10,
                    }}
                  >
                    Blank
                  </Text>
                </View>
              </View>
            </View>
            <View>
              <View
                style={{
                  backgroundColor: AppColors.white,
                  marginHorizontal: 20,
                  paddingHorizontal: 20,
                  paddingVertical: 14,
                  borderRadius: 10,
                  // marginVertical: 10,
                  borderColor: "#9C49001A",
                  borderWidth: 1,
                  alignItems: "center",
                  shadowColor: "#9C4900",
                  shadowOffset: { width: 10, height: 10 },
                  shadowOpacity: 10,
                  shadowRadius: 10,
                  elevation: 3,
                }}
              >
                <View style={{ marginTop: 10, marginBottom: 10 }}>
                  <Image
                    source={AppImages.msgBoy}
                    style={{ width: 100, height: 100 }}
                  />
                </View>
                <View
                  style={{
                    marginRight: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                    }}
                  >
                    {t("common:translation.Name")}: final
                  </Text>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                    }}
                  >
                    {t("common:translation.Number")}: 78459613
                  </Text>
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20 }}></View>
          </View>
        </View>
        <View style={{ marginTop: 20 }}>
          <View
            style={{
              backgroundColor: AppColors.white,
              marginHorizontal: 20,
              //paddingHorizontal: 20,
              // paddingVertical: 14,
              borderRadius: 10,
              // marginVertical: 10,
              borderColor: "#9C49001A",
              borderWidth: 1,
            }}
          >
            <View
              style={[
                styles.FlatImg,
                {
                  borderWidth: 1,
                  borderColor: "#9C49001A",
                  backgroundColor: AppColors.white,
                  borderRadius: 10,
                },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  marginLeft: 20,
                  paddingBottom: 14,
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    // alignItems: "center",
                    width: "40%",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                      marginTop: 10,
                    }}
                  >
                    {t("common:translation.Daily Dispatch Statistics")}
                  </Text>
                </View>
                <View
                  style={{
                    width: "60%",
                  }}
                >
                  <CustomCalendarSmall />
                </View>
              </View>
            </View>
            <View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingVertical: 10,
                  paddingHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.Order")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    5
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.Order Delivered")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    3
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.Order Pending")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    1
                  </Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingVertical: 10,
                  paddingHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.In Progress")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    0
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.Order return")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    2
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.Monthly Orders")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    24
                  </Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingVertical: 10,
                  paddingHorizontal: 20,
                }}
              >
                <TouchableOpacity
                  style={{
                    padding: 10,
                    width: "33%",
                    height: 110,
                  }}
                >
                  <View
                    style={{
                      height: 55,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassMedium,
                        // width: "50%",
                        marginBottom: 15,
                      }}
                    >
                      {t("common:translation.Monthly Delivery")}
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassSemiBold,
                    }}
                  >
                    8
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 20 }}>
          <View
            style={{
              backgroundColor: AppColors.white,
              marginHorizontal: 20,
              //paddingHorizontal: 20,
              // paddingVertical: 14,
              borderRadius: 10,
              // marginVertical: 10,
              borderColor: "#9C49001A",
              borderWidth: 1,
            }}
          >
            <View
              style={[
                styles.FlatImg,
                {
                  borderWidth: 1,
                  borderColor: "#9C49001A",
                  backgroundColor: AppColors.white,
                  borderRadius: 10,
                },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  marginLeft: 20,
                  paddingBottom: 14,
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    // alignItems: "center",
                    width: "40%",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 18,
                      fontFamily: AppFonts.OverpassBold,
                      marginTop: 10,
                    }}
                  >
                    {t("common:translation.Summary")}
                  </Text>
                </View>
                <View
                  style={{
                    width: "60%",
                  }}
                >
                  <CustomCalendarSmall />
                </View>
              </View>
            </View>
            <View
              style={{
                paddingHorizontal: 20,
                paddingBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <View
                  style={{
                    width: "40%",
                    justifyContent: "center",
                    padding: 10,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginBottom: 10,
                    }}
                  >
                    {t("common:translation.Delivery Person")}
                  </Text>
                </View>
                <View
                  style={{
                    width: "30%",
                    justifyContent: "center",
                    padding: 10,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginBottom: 10,
                    }}
                  >
                    {t("common:translation.Orders assigned")}
                  </Text>
                </View>
                <View
                  style={{
                    width: "30%",
                    justifyContent: "center",
                    padding: 10,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.dualbrown,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassMedium,
                      marginBottom: 10,
                    }}
                  >
                    {t("common:translation.Orders Status")}
                  </Text>
                </View>
              </View>
              <FlatList
                data={summaryData}
                keyExtractor={(item, index) => index.toString()}
                renderItem={({ item }) => (
                  <View
                    style={{
                      flexDirection: "row",
                      borderRadius: 15,
                      borderWidth: 1,
                      borderColor: AppColors.sandal,
                      marginBottom: 10,
                    }}
                  >
                    <View
                      style={{
                        width: "40%",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassBold,
                        }}
                      >
                        {item.deliveryPerson}
                      </Text>
                    </View>
                    <View
                      style={{
                        width: "30%",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassBold,
                        }}
                      >
                        {item.ordersAssigned}
                      </Text>
                    </View>
                    <View
                      style={{
                        width: "30%",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassBold,
                        }}
                      >
                        {item.ordersStatus}
                      </Text>
                    </View>
                  </View>
                )}
              />
            </View>
          </View>
        </View>
        <View style={{ marginBottom: 20 }}></View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default DispatchDashboard;
const styles = StyleSheet.create({
  MainView: { backgroundColor: AppColors.sandal, flex: 1 },
  SecMain: { backgroundColor: AppColors.white, marginHorizontal: 20 },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 20,
    width: "100%",
    height: height * 0.07,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "90%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    height: height * 0.07,
    borderWidth: 1,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginTop: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    margin: 10,
    marginLeft: 20,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { marginLeft: 20 },
  FlatTxtSec: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  LineBars: {
    width: "100%",
    right: 20,
    // position: 'absolute',
    borderTopColor: AppColors.brown,
    borderTopWidth: 0.7,
    opacity: 0.099,
    marginTop: 10,
  },
  CopyText: {
    fontSize: 14,
    marginTop: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
    fontWeight: "700",
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    // fontWeight: '700',
  },
  Row: { flexDirection: "row", flex: 1, alignItems: "center" },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
  },
});
